import { useQuery } from '@tanstack/react-query';

import { cacheKeys } from '../config';
import { tagClient } from '../client/tagClient';


type Options = {
  enabled: boolean
  retry?: boolean;
};

const defaultOptions: Partial<Options> = {
  enabled: true,
  retry: false,
};

export const useStoryTagsQuery = (params: Stories.TagGetListParams = {}, options: Partial<Options> = defaultOptions) => {
  const { data: { data } = {}, ...rest } = useQuery({
    queryKey: [cacheKeys.getStoryTags, params],
    queryFn: () => tagClient.getTags(params),
    enabled: options.enabled !== undefined ? options.enabled : defaultOptions.enabled,
    retry: options.retry !== undefined ? options.retry : defaultOptions.retry,
  });

  return {
    ...rest,
    count: data?.count || 0,
    tags: data?.results || [],
  };
};
